import { officeOrderFinanceAnalyticsConstants } from "../actions/constants";

const initState = {
    loading: false,
    error: null,
    office: null,
    order: null,
    finance: null,
    calendar: null,
    chart: [],
    operations: [],
    monthKey: "",
    range: null,
};

export default function officeOrderFinanceAnalyticsReducer(state = initState, action) {
    switch (action.type) {
        case officeOrderFinanceAnalyticsConstants.GET_OFFICE_ORDER_FINANCE_ANALYTICS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case officeOrderFinanceAnalyticsConstants.GET_OFFICE_ORDER_FINANCE_ANALYTICS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                office: action.payload?.office || null,
                order: action.payload?.order || null,
                finance: action.payload?.finance || null,
                calendar: action.payload?.calendar || null,
                chart: Array.isArray(action.payload?.chart) ? action.payload.chart : [],
                operations: Array.isArray(action.payload?.operations) ? action.payload.operations : [],
                monthKey: action.payload?.monthKey || action.payload?.calendar?.monthKey || "",
                range: action.payload?.range || null,
            };

        case officeOrderFinanceAnalyticsConstants.GET_OFFICE_ORDER_FINANCE_ANALYTICS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload?.error || "Ошибка загрузки финансов заказа",
            };

        case officeOrderFinanceAnalyticsConstants.CLEAR_OFFICE_ORDER_FINANCE_ANALYTICS:
            return {
                ...initState,
            };

        default:
            return state;
    }
}
